var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08324 4.14999C7.01657 4.14999 6.1499 5.01666 6.1499 6.08333C6.1499 7.14999 7.01657 8.01666 8.08324 8.01666C9.1499 8.01666 10.0166 7.14999 10.0166 6.08333C10.0166 5.01666 9.1499 4.14999 8.08324 4.14999Z",
    fill: "#414B56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08333 9.41666C6.21667 9.41666 4.75 7.88333 4.75 6.08333C4.75 4.28333 6.28333 2.75 8.08333 2.75C9.88333 2.75 11.4167 4.28333 11.4167 6.08333C11.4167 7.88333 9.95 9.41666 8.08333 9.41666ZM15.4167 5.21666C13.6833 2.55 10.95 0.949997 8.08333 0.949997C5.21667 0.949997 2.48333 2.55 0.75 5.21666C0.416667 5.75 0.416667 6.41666 0.75 6.95C2.48333 9.61666 5.21667 11.2167 8.08333 11.2167C10.95 11.2167 13.6833 9.61666 15.4167 6.95C15.8167 6.41666 15.8167 5.75 15.4167 5.21666Z",
    fill: "#414B56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductPreview);
export default __webpack_public_path__ + "static/media/icon_product_preview.b345fa2094ca640160cd112fa474793d.svg";
export { ForwardRef as ReactComponent };